module.exports = __webpack_public_path__ + "static/media/logo.c6fe342a.svg";